import React, {PropTypes} from 'react';
import {Link} from 'react-router-dom';
import {FormattedMessage} from 'react-intl';
import Select from 'react-select';

import SideNav from './SideNav';
import NavBtn from './NavBtn';
import Overlay from '../restaurant/core/Overlay';
import Languages from './Languages';
import ListViewIcon from './ListViewIcon';
import ListViewValue from './ListViewValue';

class TopBar extends React.Component {
  static propTypes = {
    back_btn: PropTypes.bool,
    catName: PropTypes.string,
    category: PropTypes.string,
    city: PropTypes.string,
    country: PropTypes.string,
    history: PropTypes.object,
    lang: PropTypes.string,
    languages: PropTypes.array,
    match: PropTypes.object,
    name: PropTypes.string,
    package: PropTypes.number,
    pathname: PropTypes.string,
    restaurant: PropTypes.string,
    social: PropTypes.object,
    title:  PropTypes.oneOfType([
              PropTypes.string,
              PropTypes.object
            ]),
    view: PropTypes.string,
    viewToggle: PropTypes.string,
    viewSort: PropTypes.func,
    wine_slug: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.state = {
      navToggle: 'inactive',
      toggle: 'inactive',
      overlay: 'inactive'
    };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    if (e.target.dataset.value === 'nav') {
      if (this.state.navToggle === 'inactive') {
        this.setState({navToggle: 'active', overlay: 'active', toggle: 'inactive'});
      } else {
        this.setState({navToggle: 'inactive', overlay: 'inactive'});
      }
    } else {
      this.setState({toggle: 'inactive', overlay: 'inactive', navToggle: 'inactive'});
    }
  }

  sortTitle() {
    if (!this.props.title) {
      return null;
      // return (
      //   <Link className="pickly-logo"
      //         to={'/' + this.props.lang + '/' + this.props.restaurant}>
      //     <img src={require('../../images/logo.png')}/>
      //   </Link>
      // );
    }
    else {
      return (
        <h2 className="bar-title">{this.props.title}</h2>
      );
    }
  }

 checkBack() {
    if (this.props.back_btn === true) {
      return (
        <button className="btn back-btn" onClick={this.props.history.goBack}/>
      );
    }
    else {
      return (
        <NavBtn toggle={this.state.navToggle} onClick={this.handleClick}/>
      );
    }
  }

  viewSort() {
    if (this.props.viewToggle) {
      return (
        <Select
          className="list-view-toggle topbar-select"
          searchable={false}
          name="view-toggle-field"
          clearable={false}
          arrowRenderer={null}
          value={this.props.viewToggle}
          placeholder={this.props.viewToggle}
          onChange={(e) => this.props.viewSort(e.value)}
          options={[
            { value: 'list', label: 'list' },
            { value: 'cards', label: 'cards' },
            /*{ value: 'tiles', label: 'tiles' },*/
            
          ]}
          optionComponent={ListViewIcon}
          valueComponent={ListViewValue}
        />
      );
    }
    else {
      return (
       null
      );
    }
  }

  render() {
    return (
      <div className="fixed top-bar">
        <div className="content-wrapper">
          {this.checkBack()}
          <Link className="pickly-logo-desktop"
                to={'/' + this.props.lang + '/' + this.props.restaurant}>
            <img src={require('../../images/logo.png')}/>
          </Link>
          <h1 className="bar-title restaurant-name">
            <Link to={'/' + this.props.lang + '/' + this.props.restaurant}>
              {this.props.name}
            </Link>
          </h1>
          {this.props.view === 'detail' ?
            <h2 className="bar-title category-name">
              <Link to={'/' + this.props.lang + '/' + this.props.restaurant + '/items/' + this.props.category + '/'}>
                {this.props.catName}
              </Link>
            </h2>
            : null}
          {this.sortTitle()}
          <div className="mobile-languages">
            <Languages languages={this.props.languages}
                       restaurant={this.props.restaurant}
                       lang={this.props.lang}
                       pathname={this.props.pathname} match={this.props.match}/>
          </div>
          {this.viewSort()}
        </div>
        {this.props.view !== 'error' ?
          <div className={"side-nav" + " " + this.state.navToggle} id="sideNav">
            <SideNav restaurant={this.props.restaurant}
                     name={this.props.name} city={this.props.city} onClick={this.handleClick}
                     country={this.props.country} lang={this.props.lang}
                     social={this.props.social} wine={this.props.wine_slug} view={this.props.view}
                     package={this.props.package}>

              <div className="desktop-languages">
                <FormattedMessage id="desktop_languages">
                  {(message) => <h5 className="desktop-languages-title">{message}</h5>}
                </FormattedMessage>
                <Languages languages={this.props.languages}
                           restaurant={this.props.restaurant}
                           lang={this.props.lang}
                           pathname={this.props.pathname} match={this.props.match}/>
              </div>
            </SideNav>
          </div>
          : null
        }
        <Overlay onClick={this.handleClick} toggle={this.state.overlay}/>
      </div>
    );
  }
}

export default TopBar;



/** WEBPACK FOOTER **
 ** ./src/components/nav/TopBar.js
 **/